<template>
  <div>

    <div v-if="error" class="alert alert-primary bg-primary text-white border-0 show">
      {{$t(error)}}
    </div>

    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-3">
          Teema
        </div>
        <div class="col-9 mb-1">
          {{subject}}
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          Saaja(d)
        </div>
        <div class="col-9 mb-1">
          <template v-for="email in client.invoiceEmails">
            <a :href="'mailto:' + email" class="mr-1">{{email}}</a>
          </template>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          Lisanduvad saajad:
        </div>
        <div class="col">
          <validated-form-input name="extraEmail" placeholder="Lisanduv e-mail"
                                v-model="extraEmail"
                                validate="email" :validator="$validator"/>
        </div>
        <div class="col">
          <validated-form-input name="extraEmail2" placeholder="Lisanduv e-mail"
                                v-model="extraEmail2"
                                validate="email" :validator="$validator"/>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          Kommentaar:
        </div>
        <div class="col-9">
          <validated-form-textarea name="comment" placeholder="Kommentaar kirja sisule"
                                   v-model="comment" :rows="2" :maxRows="8" @input="commentChanged"
                                   :validator="$validator" validate="max:600"/>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <pre class="bg-light p-3">{{preview}}</pre>
        </div>
      </div>

      <div class="list-group mb-3 attachments">
        <div class="list-group-item d-flex justify-content-between align-items-center p-1">
          <div class="p-1">bill-{{invoice.number}}.pdf</div>
          <small class="muted float-right">(lisatakse automaatselt)</small>
        </div>
        <div class="list-group-item d-flex justify-content-between align-items-center p-1" v-if="declarations && declarations.length > 0">
          <div class="p-1">{{declarations.join(", ")}}</div>
          <button type="button" class="btn btn-link btn-sm float-right">
            <i class="mdi mdi-delete" @click="removeDeclarations()"></i>
          </button>
        </div>
        <div class="list-group-item d-flex justify-content-between align-items-center p-1"
             v-for="(attachment, index) in attachments">
          <div class="p-1">{{attachment.name}} <small>{{attachment.size}} kb</small></div>
          <button type="button" class="btn btn-link btn-sm float-right">
            <i class="mdi mdi-delete" @click="removeAttachment(index)"></i>
          </button>
        </div>
      </div>

      <div class="modal-footer mx-n2 mb-n2">
        <b-button type="button" variant="secondary" @click="selectFile" class="add-attachment">
          <i class="mdi mdi-attachment" v-if="!sendingDisabled"></i>
          <span>Lisa manus...</span>
        </b-button>
        <submit-button class="ml-auto" variant="success" :disabled="sendingDisabled">
          <i class="mdi mdi-loading mdi-spin mr-1" v-if="sendingDisabled"></i>
          <i class="mdi mdi-email mr-1" v-if="!sendingDisabled"></i>
          <span>Saada</span>
        </submit-button>
      </div>

      <input ref="fileinput" type="file" multiple @change="filesSelected" tabindex=-1 style="display: none">
    </b-form>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import ValidatedFormTextarea from '@/components/ValidatedFormTextarea'
  import ValidatedFormInput from '@/components/ValidatedFormInput'

  export default {
    props: ['invoice'],
    components: {ValidatedFormInput, ValidatedFormTextarea},
    data() {
      return {
        client: {},
        subject: `Arve nr. ${this.invoice.number}`,
        comment: '',
        preview: '',
        timer: null,
        declarations: [],
        attachments: [],
        extraEmail: '',
        extraEmail2: '',
        error: null,
        sendingDisabled: true
      }
    },
    created() {
      gateway
        .get('/clients/' + this.invoice.client.id)
        .then(r => {
          this.client = r.data
          this.declarations = this.invoice.declarations.filter(declaration => !!declaration.pdfName).map(declaration => declaration.pdfName);
          this.$emit('title', 'Saada arve e-mailiga kliendile ' + this.client.name)
          this.sendingDisabled = false
        })
      this.loadPreview()
    },
    methods: {
      removeDeclarations() {
        this.declarations = [];
      },
      removeAttachment(index) {
        this.error = null
        this.attachments.splice(index, 1)
      },
      selectFile() {
        this.$refs.fileinput.dispatchEvent(new MouseEvent('click'))
      },
      filesSelected(event) {
        this.error = null
        const tooBigFiles = []
        for (const file of event.target.files) {
          if (file.size > 10 * 1024 * 1024)
            tooBigFiles.push(file.name)
          else
            this.uploadFile(file)
        }
        if (tooBigFiles.length)
          this.error = 'Need failid ületavad lubatud suurust 10 mb: ' + tooBigFiles.join(', ')
        event.target.value = ''
      },
      uploadFile(file) {
        const reader = new FileReader()
        reader.onload = () => {
          const dataUrl = reader.result
          this.attachments.push({name: file.name, content: dataUrl, size: (file.size/1024).toFixed(1)})
        }
        reader.readAsDataURL(file)
      },
      commentChanged() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.loadPreview(), 300)
      },
      loadPreview() {
        gateway.post(`/invoices/${this.invoice.id}/send/preview`, {comment: this.comment})
          .then(r => this.preview = r.data)
      },
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return

          this.sendingDisabled = true

          let data = {
            recipients: this.client.invoiceEmails,
            subject: this.subject,
            comment: this.comment,
            attachments: this.attachments,
            includeDeclarations: this.declarations && this.declarations.length > 0
          }

          if (!!this.extraEmail && this.extraEmail.length > 1) {
            data.recipients.push(this.extraEmail)
          }

          if (!!this.extraEmail2 && this.extraEmail2.length > 1) {
            data.recipients.push(this.extraEmail2)
          }

          gateway.post(`/invoices/${this.invoice.id}/send`, data)
            .then(() => {
              this.$notifications.info(`Arve on saadetud aadressile ${this.client.invoiceEmail}.`)
              this.$emit('done')
            })
            .catch(r => {if (r.response) this.error = r.response.data.key})
            .finally(() => this.sendingDisabled = false)
        })
      }
    }
  }
</script>
